<script>
import useEnergyAdjustmentCoefficients
  from "@/composables/financial_management/definition_adjustment_coefficients/energy_adjustment_coefficients/useEnergyAdjustmentCoefficients"
import EnergyDataTable
  from "@/components/Financial_management_and_productivity/DefineAdjustmentCoefficients/EnergyAdjustmentCoefficients/EnergyDataTable.vue";
import Preloader from "@/components/Preloader/Preloader.vue";

export default {
  components: {Preloader, EnergyDataTable},
  async mounted() {
    await this.fetchData('material')
  },

  data() {
    return {
      ...useEnergyAdjustmentCoefficients().data(),
    }
  },

  methods: {
    ...useEnergyAdjustmentCoefficients().methods,
  }
}
</script>

<template>
  <Preloader :loading="isLoading"/>
  <div class="p-3" v-if="years?.length > 0 && items?.length > 0">
    <EnergyDataTable
        v-for="(item, index) in items"
        :key="index"
        :energyData="item"
        :years="years"
        class="mb-5"
    />
  </div>


  <div v-else class="alert alert-info m-3">
    موردی وجود ندارد
  </div>
</template>
